import { put, call } from 'redux-saga/effects';
import * as staffApi from '../../services/staffApi';

const initialState = {
  attrList: [],
};

export const state = initialState;

export const effects = {
  *getStaffAttrList(action) {
    const response = yield call(staffApi.getStaffAttrList);
    if (response) {
      yield put({
        type: 'staff/setState',
        payload: { attrList: response.ret || [] }
      })
    }
  },
};
